import React from "react";
import { injectIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import { useFormik } from "formik";
import * as yup from "yup";
import { AuthWrapper } from "../../../../components/AuthWrapper/AuthWrapper";
import InputField from "../../../../components/Controls/Input/Input";
import { ButtonComponent } from "../../../../components/Controls/Button/Button";
import Spinner from "../../../../components/Spinner/Spinner";
import { PASSWORD_PATTERN } from "../../../../utils/validations";
import "./setPassword.scss";
import { useLocation } from "react-router-dom";
import { agenciesResetPasswordRequest } from "../../../../store/authentication/actions";

const AgenciesSetPassword = ({ intl: { messages }, inDialog, handleCancel }) => {
  const loader = useSelector((state) => state.loader);
  const dispatch = useDispatch();
  const  location  = useLocation();
  const existToken = localStorage.getItem("token");

  const token = location.search.split("&")[0].split("=")[1];

  const resetPasswordSchema = yup.object().shape({
    password: yup
      .string()
      .min(8, messages.auth.errors.passwordLength)
      .matches(PASSWORD_PATTERN, messages.auth.errors.passwordPattern)
      .required(messages.auth.errors.required),
    confirmPassword: yup.string().when("password", {
      is: (val) => (val && val.length > 0 ? true : false),
      then: yup
        .string()
        .oneOf([yup.ref("password")], messages.auth.errors.confirmPassword),
    }),
  });

  const formik = useFormik({
    initialValues: {
      token: token,
      password: "",
    },
    validationSchema: resetPasswordSchema,
    onSubmit: (values) => {
      dispatch(
        agenciesResetPasswordRequest({
          password: values?.password,
          token: values.token,
          from_profile: inDialog,
        })
      );
    },
  });

  const renderFormContent = () => {
    return (
      <div style={{ display: 'flex', alignItems: 'center', height: 'calc(100% - 35px)' }}>
        <div style={{ width: '100%' }}
          className={inDialog ? "resetPassword-form mt-4" : "resetPassword-form"}
        >
          {!inDialog && <div className="resetPassword-form_logo"></div>}
          <div className="resetPassword-form_lock"></div>
          <h3 className="resetPassword-form_form-header">
            {messages.auth.setPassword}
          </h3>
          <form onSubmit={formik.handleSubmit}>
            <InputField
              isRequired={true}
              id="password"
              name="password"
              label={messages.formControl.password}
              type="password"
              value={formik.values.password}
              onChange={formik.handleChange}
              error={formik.touched.password && Boolean(formik.errors.password)}
              helperText={formik.touched.password && formik.errors.password}
              placeholder={messages.formControl.password}
            />
            <InputField
              isRequired={true}
              id="confirmPassword"
              name="confirmPassword"
              label={messages.formControl.confirmPassword}
              type="password"
              value={formik.values.confirmPassword}
              onChange={formik.handleChange}
              error={
                formik.touched.confirmPassword &&
                Boolean(formik.errors.confirmPassword)
              }
              helperText={
                formik.touched.confirmPassword && formik.errors.confirmPassword
              }
              placeholder={messages.formControl.confirmPassword}
            />
            {inDialog ? (
              <div className="d-flex justify-content-center">
                <ButtonComponent
                  content={
                    loader ? <Spinner color={"white"} /> : messages.common.change
                  }
                  variant="contained"
                  classes="mx-2 px-5 my-2 form-submit-btn"
                  handleClick={formik.handleSubmit}
                  color="primary"
                />
                <ButtonComponent
                  content={messages.common.cancel}
                  variant="outlined"
                  classes="mx-2 px-5 my-2 form-submit-btn"
                  handleClick={handleCancel}
                  color="primary"
                />
              </div>
            ) : (
              <ButtonComponent
                content={
                  <>{loader ? <Spinner color={"white"} /> : messages.auth.send}</>
                }
                variant="contained"
                classes="mx-auto w-100 my-2 form-submit-btn"
                handleClick={formik.handleSubmit}
                color="primary"
              />
            )}
          </form>
        </div>
      </div>
    );
  };

  if (existToken) return 'You are logged in !';

  return inDialog ? (
    renderFormContent()
  ) : (
    <AuthWrapper
      content={renderFormContent()}
      handleSubmit={formik.handleSubmit}
    />
  );
};

export default injectIntl(AgenciesSetPassword);
